import * as React from "react";

import styles from "./Header.module.scss";
import imageLogoGreen from "./images/logo-green.svg";

const Header = () => (
  <nav className={styles["hero-nav"]}>
    <a href="https://www.duolingo.com">
      <img
        alt="Duolingo"
        className={styles["hero-logo"]}
        src={imageLogoGreen}
      />
    </a>
  </nav>
);

export default Header;
